import type { HtmlAttributes, HtmlAttributesWithChildren } from '@studio/design-system/props';
import type { Accessor } from '@studio/react-utils';
import type { T_Optional } from '@tryiris-ai/js-types';

/** `<Placeholder>` properties. */
export type PlaceholderProps = Props;

/** `<RightTray>` properties. */
export type Props = HtmlAttributes;

/** `<Root>` properties. */
export type RootProps = HtmlAttributesWithChildren<{ tab: Accessor<Tab, unknown> }>;

/** `<Trigger>` properties. */
export type TriggersProps = HtmlAttributes<T_Optional<{ disabled: boolean }>>;

/** Tabs. */
export enum Tab {
  Controls = 'controls',
  Image = 'image'
}
